export default "__VITE_ASSET__DVr5TZqC__"